import { hasServiceAccess } from './serviceWorkspace'

export const resolveDefaultAuthenticatedRoute = (user = {}) => {
  const authLevel = Number(user?.authLevel || 0)

  if (authLevel >= 90) return '/admin/parcel-info'
  if (authLevel !== 80) return '/'

  if (hasServiceAccess(user, 'logis')) return '/admin/parcel-info'
  if (hasServiceAccess(user, 'fulfillment')) return '/admin/fulfillment/sku-requests'
  if (hasServiceAccess(user, 'inventory')) return '/admin/inventory'

  return '/'
}
